import { makeCancellableAPIRequest } from "restAPI";
import { BaseResponseDto } from "types/api/baseResponseDto";
import {
  AnyaAgentDeleteResponse,
  AnyaAgentDetails,
  AnyaAgentMutationPayload,
  AnyaAgentMutationResponse,
  AnyaAgentsListParams,
  AnyaAgentsListResponse,
} from "views/Automations/AnyaAgents/types";

const BASE_URL = "/api/ai/anya-agents";

export function getAnyaAgents(params?: AnyaAgentsListParams) {
  return makeCancellableAPIRequest<BaseResponseDto<AnyaAgentsListResponse>>(
    "GET",
    BASE_URL,
    {
      params,
    },
  );
}

export function getAnyaAgentDetails(agentId: number) {
  return makeCancellableAPIRequest<BaseResponseDto<AnyaAgentDetails>>(
    "GET",
    `${BASE_URL}/${agentId}`,
  );
}

export function createAnyaAgent(data: AnyaAgentMutationPayload) {
  return makeCancellableAPIRequest<BaseResponseDto<AnyaAgentMutationResponse>>(
    "POST",
    BASE_URL,
    {
      data,
    },
  );
}

export function updateAnyaAgent(
  agentId: number,
  data: AnyaAgentMutationPayload,
) {
  return makeCancellableAPIRequest<BaseResponseDto<AnyaAgentMutationResponse>>(
    "PUT",
    `${BASE_URL}/${agentId}`,
    {
      data,
    },
  );
}

export function deleteAnyaAgent(agentId: number, note?: string) {
  const trimmedNote = note?.trim();

  return makeCancellableAPIRequest<BaseResponseDto<AnyaAgentDeleteResponse>>(
    "DELETE",
    `${BASE_URL}/${agentId}`,
    trimmedNote
      ? {
          data: {
            note: trimmedNote,
          },
        }
      : undefined,
  );
}
